module.exports = __webpack_public_path__ + "static/media/map-light.be3d2434.svg";